var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNadajesidozamraaniaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.18 52.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.8 27.99 38.7 32.65 28 26.47 38.7 20.3 48.8 24.95 50.18 21.96 42.19 18.28 48.74 14.5 47.28 11.97 40.73 15.76 41.54 7 38.26 6.7 37.24 17.77 26.55 23.95 26.55 11.6 35.63 5.18 33.73 2.49 26.55 7.57 26.55 0 23.63 0 23.63 7.57 16.45 2.49 14.55 5.18 23.63 11.6 23.63 23.95 12.94 17.77 11.91 6.7 8.64 7 9.45 15.76 2.89 11.97 1.43 14.5 7.99 18.28 0 21.96 1.38 24.95 11.48 20.3 22.17 26.47 11.48 32.65 1.38 27.99 0 30.98 7.99 34.66 1.43 38.45 2.89 40.97 9.45 37.18 8.64 45.94 11.91 46.25 12.94 35.17 23.63 29 23.63 41.35 14.55 47.77 16.45 50.45 23.63 45.37 23.63 52.94 26.55 52.94 26.55 45.37 33.73 50.45 35.63 47.77 26.55 41.35 26.55 29 37.24 35.17 38.26 46.25 41.54 45.94 40.73 37.18 47.28 40.97 48.74 38.45 42.19 34.66 50.18 30.98 48.8 27.99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNadajesidozamraaniaIcon);
export default __webpack_public_path__ + "static/media/Nadaje się do zamrażania_icon.2ed8ae644f766cb86ecde9fb46919b15.svg";
export { ForwardRef as ReactComponent };